import {
    FontDownloadRounded,
    FormatColorTextRounded,
} from '@mui/icons-material';
import ColorButton from './ColorButton';
import { useTranslation } from 'react-i18next';

function ColorButtons() {
    const { t } = useTranslation();

    return (
        <>
            <ColorButton
                format="color"
                Icon={FormatColorTextRounded}
                tooltip={t('Text Color')}
            />
            <ColorButton
                format="backgroundColor"
                Icon={FontDownloadRounded}
                tooltip={t('Background Color')}
            />
        </>
    );
}

export default ColorButtons;
